import { NOT_ENROLLED } from '@atlassian/jira-common-util-get-experiment-group';
import { getFeatureFlagClient } from '@atlassian/jira-feature-flagging';
import type { FeatureFlagValue } from '../../types';

export const fireExposureEvent = (
	featureFlagKey: string,
	flagValue: FeatureFlagValue,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	attributes: any = {},
): void => {
	const cohort = flagValue.value;
	if (!cohort.startsWith(NOT_ENROLLED)) {
		getFeatureFlagClient().trackExposure(
			featureFlagKey,
			{
				value: cohort,
				explanation: {
					kind: flagValue?.explanation.kind,
					ruleId: flagValue?.explanation.ruleId || undefined,
				},
			},
			attributes,
		);
	}
};
